(() => {
  if (customElements.get('section-reviews')) {
    return;
  }

  class SectionReviews extends HTMLElement {
    constructor() {
      super();
      this.overlay = this.querySelector('.js-overlay');
    }

    connectedCallback() {
      this.querySelector('.js-more').addEventListener(
        'click',
        this.loadMore.bind(this),
      );
    }

    loadMore(event) {
      event.preventDefault();
      this.overlay.classList.add('hidden');

      document.querySelectorAll('.js-tile.is-hidden').forEach((el) => {
        el.classList.remove('is-hidden');
      });

      this.querySelector('reviews-masonry-layout').refresh();
    }
  }

  customElements.define('section-reviews', SectionReviews);
})();
